<div class="dialog">
  <div mat-dialog-title>Buy Multiple Replacements<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content>
  <div style="margin: 0 0 10px 0">
    Reinvest the cash generated from the security sold into the below securities:
  </div>

  <div class="bold">
    {{numberReplacements}} Replacement Securities
  </div>

  <div>
    <div>Add replacement securities</div>
    @if (!isReadOnly) {
      <irb-dropdown-search-multiple #securitiesDropdown
        [(values)]="securitiesList"
        (search)="getSecurities($event)"
        (selection)="onSecuritiesChange($event)"
        [enableHiddenSearchResults]="true"
        [addNewItem]="addNewSecurityItem"
        (openNewItemFlow)="openNewItemSecurityFlow($event)"
        style="width: 300px !important;vertical-align: middle;" size="30">
      </irb-dropdown-search-multiple>
    }
    @if (isReadOnly) {
      <select [disabled]='true' style="width:260px;height:24px;margin-right:5px">
      </select>
    }
    <button (click)="addSecuritiesFromDropdown()" [disabled]="securitiesList ? securitiesList.length === 0 : true" class="btn-medium-secondary btn-spacer">Add</button>
  </div>

  <div class="block">@if (!isUiTest) {
    <irb-inventory-grid
      [style.height] = "'100%'"
      [gridHeight] = "'240px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)"
    ></irb-inventory-grid>
  }</div>

  <div class="right"><span class="bold">Total (must equal 100%):&nbsp;</span><span [style]="{color: totalAllocationValue === 100 ? '#188800' : '#C11312'}">{{totalAllocationValue | number:"1.2-2" | negativeNumber: "": "%"}}</span></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" [disabled]="isReadOnly" class="btn-medium-secondary">Cancel</button>
  <button id="doneButton" (click)="done()" [disabled]="isReadOnly" class="btn-medium-primary" >Done</button>
</mat-dialog-actions>
</div>

